// CART UNIFIER 29/4/2026

document.addEventListener('keydown', function (e) {
  const isQtyInput = e.target.matches(
    '.t4s-mini_cart__actions input[data-quantity-value], .t4s-page_cart__actions input[data-quantity-value]'
  );

  if (!isQtyInput) return;

  if (e.key === 'Enter') {
    console.log('[JD1] Enter bloqueado en input de cantidad');

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Opcional: quitar foco para que el theme procese el cambio
    e.target.blur();
  }
}, true);

const JD1_VARIANT_THRESHOLDS = [
  { name: 'Buy 1 - 2', min: 1, max: 2 },
  { name: 'Buy 3 - 4', min: 3, max: 4 },
  { name: 'Buy 5 - 9', min: 5, max: 9 },
  { name: 'Buy 10 - 24', min: 10, max: 24 },
  { name: 'Buy 25+', min: 25, max: Infinity }
];

let jd1CartUnifierLock = false;
let jd1CartUnifierTimer = null;
const jd1ProductCache = new Map();

function jd1SafeQueryAll(selector, root = document) {
  try {
    return Array.from(root.querySelectorAll(selector));
  } catch {
    return [];
  }
}

function jd1SafeQuery(selector, root = document) {
  try {
    return root.querySelector(selector);
  } catch {
    return null;
  }
}

function jd1DisableCartControls() {
  console.log('[JD1] disabling cart controls');

  jd1SafeQuery('#t4s-mini_cart')?.classList.add('is--contentUpdate');
  jd1SafeQuery('.t4s-cartPage__form')?.classList.add('is--contentUpdate');

  const selectors = [
    '.t4s-mini_cart__actions input[data-quantity-value]',
    '.t4s-mini_cart__actions [data-quantity-selector]',
    '.t4s-page_cart__actions input[data-quantity-value]',
    '.t4s-page_cart__actions [data-quantity-selector]'
  ];

  selectors.forEach(selector => {
    jd1SafeQueryAll(selector).forEach(el => {
      el.disabled = true;
      el.setAttribute('aria-disabled', 'true');
    });
  });

  jd1SafeQueryAll('.t4s-mini_cart__items, .t4s-table-main-cart').forEach(el => {
    el.style.pointerEvents = 'none';
  });
}

function jd1EnableCartControls() {
  console.log('[JD1] enabling cart controls');

  jd1SafeQuery('#t4s-mini_cart')?.classList.remove('is--contentUpdate');
  jd1SafeQuery('.t4s-cartPage__form')?.classList.remove('is--contentUpdate');

  const selectors = [
    '.t4s-mini_cart__actions input[data-quantity-value]',
    '.t4s-mini_cart__actions [data-quantity-selector]',
    '.t4s-page_cart__actions input[data-quantity-value]',
    '.t4s-page_cart__actions [data-quantity-selector]'
  ];

  selectors.forEach(selector => {
    jd1SafeQueryAll(selector).forEach(el => {
      el.disabled = false;
      el.removeAttribute('aria-disabled');
    });
  });

  jd1SafeQueryAll('.t4s-mini_cart__items, .t4s-table-main-cart').forEach(el => {
    el.style.pointerEvents = '';
  });
}

function jd1GetThresholdName(quantity) {
  const matched = JD1_VARIANT_THRESHOLDS.find(item => {
    return quantity >= item.min && quantity <= item.max;
  });

  return matched ? matched.name : null;
}

async function jd1FetchCart() {
  const res = await fetch('/cart.js', {
    credentials: 'same-origin',
    cache: 'no-store'
  });

  if (!res.ok) {
    throw new Error('No se pudo leer /cart.js');
  }

  return await res.json();
}

async function jd1GetProductData(handle) {
  if (jd1ProductCache.has(handle)) {
    return jd1ProductCache.get(handle);
  }

  const res = await fetch(`/products/${handle}.js`, {
    credentials: 'same-origin',
    cache: 'force-cache'
  });

  if (!res.ok) {
    throw new Error(`No se pudo leer el producto: ${handle}`);
  }

  const productData = await res.json();
  jd1ProductCache.set(handle, productData);

  return productData;
}

async function jd1GetCorrectVariantId(handle, quantity) {
  const thresholdName = jd1GetThresholdName(quantity);

  if (!thresholdName) {
    return null;
  }

  const productData = await jd1GetProductData(handle);

  const variant = productData.variants.find(v => v.title === thresholdName);

  return variant ? variant.id : null;
}

function jd1GroupCartByProduct(cart) {
  const grouped = {};

  cart.items.forEach(item => {
    const productId = String(item.product_id);

    if (!grouped[productId]) {
      grouped[productId] = [];
    }

    grouped[productId].push(item);
  });

  return grouped;
}

async function jd1SetCartUpdates(updates) {
  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify({ updates })
  });

  if (!res.ok) {
    throw new Error('Falló /cart/update.js');
  }

  return await res.json();
}

async function jd1AddCartItem(variantId, quantity) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      id: variantId,
      quantity
    })
  });

  if (!res.ok) {
    throw new Error('Falló /cart/add.js');
  }

  return await res.json();
}

async function jd1UnifyCartIfNeeded() {
  const cart = await jd1FetchCart();

  console.log('[JD1] cart leído después de cart:updated', {
    item_count: cart.item_count,
    items: cart.items.map(item => ({
      product_id: item.product_id,
      variant_id: item.variant_id,
      title: item.title,
      quantity: item.quantity,
      key: item.key
    }))
  });

  if (!cart.items || cart.items.length === 0) {
    console.log('[JD1] carrito vacío, no se unifica');
    return false;
  }

  const grouped = jd1GroupCartByProduct(cart);
  let changed = false;

  for (const productId in grouped) {
    const group = grouped[productId];
    const handle = group[0]?.handle;
    const totalQty = group.reduce((sum, item) => sum + item.quantity, 0);

    if (!handle || totalQty <= 0) {
      continue;
    }

    const correctVariantId = await jd1GetCorrectVariantId(handle, totalQty);

    console.log('[JD1] revisión grupo', {
      productId,
      handle,
      totalQty,
      correctVariantId,
      group: group.map(item => ({
        key: item.key,
        variant_id: item.variant_id,
        title: item.title,
        quantity: item.quantity
      }))
    });

    if (!correctVariantId) {
      console.warn('[JD1] no se encontró variante correcta', {
        productId,
        handle,
        totalQty
      });

      continue;
    }

    const alreadyUnified =
      group.length === 1 &&
      Number(group[0].variant_id) === Number(correctVariantId) &&
      Number(group[0].quantity) === Number(totalQty);

    if (alreadyUnified) {
      console.log('[JD1] grupo ya está unificado', {
        productId,
        variant_id: correctVariantId,
        quantity: totalQty
      });

      continue;
    }

    changed = true;

    console.log('[JD1] grupo necesita unificación', {
      productId,
      handle,
      totalQty,
      correctVariantId
    });

    const updates = {};

    group.forEach(item => {
      updates[item.key] = 0;
    });

    console.log('[JD1] removiendo líneas', updates);

    await jd1SetCartUpdates(updates);

    console.log('[JD1] agregando variante correcta', {
      variantId: correctVariantId,
      quantity: totalQty
    });

    await jd1AddCartItem(correctVariantId, totalQty);
  }

  return changed;
}

document.addEventListener('cart:updated', function () {
  console.log('[JD1] cart:updated detectado', {
    locked: jd1CartUnifierLock
  });

  if (jd1CartUnifierLock) {
    console.log('[JD1] ignorado por lock activo');
    return;
  }

  clearTimeout(jd1CartUnifierTimer);

  jd1CartUnifierTimer = setTimeout(async function () {
    jd1CartUnifierLock = true;
    jd1DisableCartControls();

    try {
      const changed = await jd1UnifyCartIfNeeded();

      console.log('[JD1] resultado unificación', {
        changed
      });

      if (changed) {
        setTimeout(() => {
          console.log('[JD1] disparando cart:refresh');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }, 150);
      }
    } catch (err) {
      console.error('[JD1] error unificando carrito', err);
    } finally {
      setTimeout(() => {
        jd1EnableCartControls();
        jd1CartUnifierLock = false;
        console.log('[JD1] lock liberado');
      }, 700);
    }
  }, 250);
});


document.addEventListener('click', async function (e) {
  const checkoutBtn = e.target.closest(
    'button[name="checkout"], input[name="checkout"], .t4s-btn__checkout'
  );

  if (!checkoutBtn) return;

  console.log('[JD1] checkout interceptado');

  const agreeCheckbox = document.querySelector('[data-agree-checkbox]');

if (agreeCheckbox && !agreeCheckbox.checked) {
  console.log('[JD1] checkbox de términos NO aceptado → no se continúa');

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  // Opcional: feedback visual mínimo
  agreeCheckbox.focus();

  return;
}

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  if (jd1CartUnifierLock) {
    console.log('[JD1] checkout bloqueado porque ya está unificando');
    return;
  }

  jd1CartUnifierLock = true;
  jd1DisableCartControls();

  try {
    console.log('[JD1] validando carrito antes de checkout');

    await new Promise(resolve => setTimeout(resolve, 300));

    const changed = await jd1UnifyCartIfNeeded();

    console.log('[JD1] validación checkout terminada', { changed });

    window.location.href = '/checkout';
  } catch (err) {
    console.error('[JD1] error antes de checkout', err);

    jd1EnableCartControls();
    jd1CartUnifierLock = false;
  }
}, true);